var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumOfArticles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.418,
    height: 91.418,
    viewBox: "0 0 91.418 91.418",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NumOfArticles",
    transform: "translate(263.083 -22.304)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5258",
    "data-name": "Rectangle 5258",
    width: 90.418,
    height: 90.418,
    rx: 3.594,
    transform: "translate(-262.583 22.804)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5259",
    "data-name": "Rectangle 5259",
    width: 64.322,
    height: 32.345,
    rx: 3.594,
    transform: "translate(-249.535 38.241)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5260",
    "data-name": "Rectangle 5260",
    width: 64.322,
    height: 7.934,
    rx: 3.594,
    transform: "translate(-249.535 76.251)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5261",
    "data-name": "Rectangle 5261",
    width: 49.789,
    height: 7.934,
    rx: 3.594,
    transform: "translate(-242.269 89.85)",
    fill: "var(--bgColor)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumOfArticles);
export default __webpack_public_path__ + "static/media/NumOfArticles.0dde76ca31605d44d5d00c6c46146d18.svg";
export { ForwardRef as ReactComponent };